//@flow
import TrackJs from './trackjs-interface';

type Item = {
  qty:number,
  title:string,
  price:number,
  id:string,
  url:string,
  vars?:Object,
  tags?:string,
};

export type Items = Item[];

export type CartParams = {
  email:string,
  items:Items,
};

export type PurchaseParams = {
  email:string,
  items:Items,
};

export default {
  userSignUp(email:string, list?:string, source?:string, callback?:(err:boolean) => void, vars?:Object) {
    if (!window.Sailthru) return callback && callback(true);

    const lists = list ? { [list]: 1 } : {};

    const addOpts:Object = {
      email,
      source,
      lists,
      onSuccess: () => callback && callback(false),
      onError: () => callback && callback(true),
    };

    if (vars) addOpts.vars = vars;

    window.Sailthru.integration('userSignUp', addOpts);
  },

  addToCart(params:CartParams) {
    if (!window.Sailthru) return;
    const onError = (err) => TrackJs.console.error(`Sailthru add to cart failed because of ${err} for ${params.email}`);
    const updatedParams = Object.assign({}, params, { onError });

    window.Sailthru.integration('addToCart', updatedParams);
  },
};
